import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '..';

export interface ContactSupportState {
  data: [] | null | any;
  totalPage: number | null;
  currentPage: number | null;
  totalRecords: number | null;
}

const initialState: ContactSupportState = {
  data: null,
  totalPage: null,
  currentPage: null,
  totalRecords: null,
};

export const contactSupportSlice = createSlice({
  name: 'contactSupport',
  initialState,
  reducers: {
    setContactSupport: (state, action) => {
      state.data = action.payload.data;
      state.totalPage = action.payload.totalPage;
      state.currentPage = action.payload.currentPage;
      state.totalRecords = action.payload.totalRecords;
    },
    addNewContactSupport: (state: any, action) => {
      state.data = [action.payload.data, ...state.data];
    },
    reset: (state) => {
      state = initialState;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setContactSupport, addNewContactSupport, reset } = contactSupportSlice.actions;
export const getContactSupport = (state: RootState) => state.contactSupport.data;
export const getContactSupportTotalRecords = (state: RootState) => state.contactSupport.totalRecords;

export default contactSupportSlice.reducer;
